import React, { useState } from "react";
import { Box } from "@mui/system";
import { EmissionsAllocationOverviewRequestBody, EmissionsAllocationExportRequestBody } from "api";
import { ReturnButton, ToggleButtonGroup } from "components";
import { EmissionsAllocationTable, ExportCSVButton, SetupsOverview } from "./components";
import { VIEWS } from "./types";

export const EmissionAllocationSummaryTab = ({ query }: { query: EmissionsAllocationOverviewRequestBody }) => {
    const [view, setView] = useState(VIEWS.SETUPS_OVERVIEW);
    const [selectedAllocationId, setSelectedAllocationId] = useState<number | null>(null);
    const [selectedView, setSelectedView] = useState(query.isDisaggregated ? 'Monthly' : 'Aggregated');
    const changeView = (newView: string) => setView(newView);

    const onOpenSetupDetailsHandler = (allocationId: number) => {
        setSelectedAllocationId(allocationId)
        changeView(VIEWS.EA_OVERVIEW);
    }

    const onBackToOverview = () => {
        changeView(VIEWS.SETUPS_OVERVIEW);
    }

    // Actualizar el query basado en el selectedView
    const updatedQuery = {
        ...query,
        isDisaggregated: selectedView === 'Monthly'
    };

    const getExportQuery = (): EmissionsAllocationExportRequestBody | null => {
        if (!query.startDate || !query.endDate || !selectedAllocationId) {
            return null;
        }

        return {
            startDate: query.startDate,
            endDate: query.endDate,
            allocationId: selectedAllocationId,
            viewType: query.viewType,
            siteIds: query.siteIds,
            utilityTypeIds: query.utilityTypeIds,
            businessUnits: query.businessUnits,
            countryRegions: query.countryRegions,
            isDisaggregated: selectedView === 'Monthly'
        };
    };

    const exportQuery = getExportQuery();

    const toggleOptions = [
        { value: 'Aggregated', label: 'Aggregated' },
        { value: 'Monthly', label: 'Monthly' }
    ];

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            {view === VIEWS.SETUPS_OVERVIEW && (
                <SetupsOverview
                    onViewDetails={onOpenSetupDetailsHandler}
                />
            )}
            {view === VIEWS.EA_OVERVIEW && query && selectedAllocationId && (
                <div style={{ paddingTop: '24px' }}>
                    <ReturnButton onClick={onBackToOverview} label='Return to Emissions Allocation Overview' />
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: '24px' }}>
                        <ToggleButtonGroup
                            options={toggleOptions}
                            selectedValue={selectedView}
                            onValueChange={setSelectedView}
                        />
                        {exportQuery && <ExportCSVButton query={exportQuery} />}
                    </div>
                    <EmissionsAllocationTable query={{ ...updatedQuery, allocationId: selectedAllocationId }} />
                </div>
            )}
        </Box>
    );
}